import React, {CSSProperties, forwardRef, useId} from "react";
import ReactSelect, {components as ReactSelectComponents, GroupBase, Props as IReactSelectProps, SelectInstance} from "react-select";
import classNames from "classnames";

import {ChevronDownIcon} from "@pg-design/icons-module";
import {Text} from "@pg-design/text-module";

import {useSelectTheme} from "../hooks/use_select_theme";
import {SELECT_TEST_CLASSNAMES} from "../utils/test_ids";

import {iconStyle} from "./Select.module.css";

export interface ISelectProps extends IReactSelectProps {
    isBorderless?: boolean;
    labelContent?: string;
    style?: CSSProperties;
    controlClassName?: string;
}

const Wrapper = (props: {children: (React.ReactNode | null)[]; hasLabel?: boolean; className?: string; style?: CSSProperties}) => {
    if (props.hasLabel) {
        return (
            <div className={props.className} style={props.style}>
                {props.children}
            </div>
        );
    }
    return <>{props.children}</>;
};

function SelectBase(props: ISelectProps, ref: React.Ref<SelectInstance<unknown, boolean, GroupBase<unknown>>>) {
    const {labelContent, isBorderless, className, placeholder, style, styles: customStyles, ...restProps} = props;

    const {getTheme, styles} = useSelectTheme(isBorderless);

    const instanceId = useId();

    return (
        <Wrapper hasLabel={!!labelContent} className={className} style={style}>
            {labelContent ? (
                <Text mb={0.5} variant="body_copy_2" as="div">
                    {labelContent}
                </Text>
            ) : null}
            <ReactSelect
                instanceId={instanceId}
                components={{
                    Control: (state) => {
                        const {className, ...innerProps} = state.innerProps;

                        return (
                            <ReactSelectComponents.Control {...state} innerProps={{...innerProps, className: classNames(props.controlClassName, className)}} />
                        );
                    },
                    DropdownIndicator: (state) => {
                        return (
                            <ChevronDownIcon
                                className={classNames(iconStyle, SELECT_TEST_CLASSNAMES.CHEVRON_ICON)}
                                size="2"
                                fill={`var(--colors-gray-${state.isDisabled ? "300" : "700"})`}
                            />
                        );
                    },
                    SingleValue: (state) => {
                        return (
                            <ReactSelectComponents.SingleValue {...state} innerProps={{...state.innerProps, className: SELECT_TEST_CLASSNAMES.SINGLE_VALUE}} />
                        );
                    },
                    MultiValue: (state) => {
                        return (
                            <ReactSelectComponents.MultiValue {...state} innerProps={{...state.innerProps, className: SELECT_TEST_CLASSNAMES.SINGLE_VALUE}} />
                        );
                    },
                    ClearIndicator: (state) => {
                        return (
                            <ReactSelectComponents.ClearIndicator
                                {...state}
                                innerProps={{...state.innerProps, className: SELECT_TEST_CLASSNAMES.CLEAR_FIELD}}
                            />
                        );
                    },
                    MultiValueRemove: (state) => {
                        return (
                            <ReactSelectComponents.MultiValueRemove
                                {...state}
                                innerProps={{...state.innerProps, className: SELECT_TEST_CLASSNAMES.REMOVE_VALUE}}
                            />
                        );
                    }
                }}
                isSearchable={false}
                theme={getTheme}
                styles={{...styles, ...customStyles}}
                {...restProps}
                className={!labelContent ? className : undefined}
                placeholder={placeholder || "Wybierz"}
                ref={ref}
            />
        </Wrapper>
    );
}

export const Select = forwardRef(SelectBase);
import React, {CSSProperties, forwardRef, useId} from "react";
import ReactSelect, {components as ReactSelectComponents, GroupBase, Props as IReactSelectProps, SelectInstance} from "react-select";
import classNames from "classnames";

import {ChevronDownIcon} from "@pg-design/icons-module";
import {Text} from "@pg-design/text-module";

import {useSelectTheme} from "../hooks/use_select_theme";
import {SELECT_TEST_CLASSNAMES} from "../utils/test_ids";

import {iconStyle} from "./Select.module.css";

export interface ISelectProps extends IReactSelectProps {
    isBorderless?: boolean;
    labelContent?: string;
    style?: CSSProperties;
    controlClassName?: string;
}

const Wrapper = (props: {children: (React.ReactNode | null)[]; hasLabel?: boolean; className?: string; style?: CSSProperties}) => {
    if (props.hasLabel) {
        return (
            <div className={props.className} style={props.style}>
                {props.children}
            </div>
        );
    }
    return <>{props.children}</>;
};

function SelectBase(props: ISelectProps, ref: React.Ref<SelectInstance<unknown, boolean, GroupBase<unknown>>>) {
    const {labelContent, isBorderless, className, placeholder, style, styles: customStyles, ...restProps} = props;

    const {getTheme, styles} = useSelectTheme(isBorderless);

    const instanceId = useId();

    return (
        <Wrapper hasLabel={!!labelContent} className={className} style={style}>
            {labelContent ? (
                <Text mb={0.5} variant="body_copy_2" as="div">
                    {labelContent}
                </Text>
            ) : null}
            <ReactSelect
                instanceId={instanceId}
                components={{
                    Control: (state) => {
                        const {className, ...innerProps} = state.innerProps;

                        return (
                            <ReactSelectComponents.Control {...state} innerProps={{...innerProps, className: classNames(props.controlClassName, className)}} />
                        );
                    },
                    DropdownIndicator: (state) => {
                        return (
                            <ChevronDownIcon
                                className={classNames(iconStyle, SELECT_TEST_CLASSNAMES.CHEVRON_ICON)}
                                size="2"
                                fill={`var(--colors-gray-${state.isDisabled ? "300" : "700"})`}
                            />
                        );
                    },
                    SingleValue: (state) => {
                        return (
                            <ReactSelectComponents.SingleValue {...state} innerProps={{...state.innerProps, className: SELECT_TEST_CLASSNAMES.SINGLE_VALUE}} />
                        );
                    },
                    MultiValue: (state) => {
                        return (
                            <ReactSelectComponents.MultiValue {...state} innerProps={{...state.innerProps, className: SELECT_TEST_CLASSNAMES.SINGLE_VALUE}} />
                        );
                    },
                    ClearIndicator: (state) => {
                        return (
                            <ReactSelectComponents.ClearIndicator
                                {...state}
                                innerProps={{...state.innerProps, className: SELECT_TEST_CLASSNAMES.CLEAR_FIELD}}
                            />
                        );
                    },
                    MultiValueRemove: (state) => {
                        return (
                            <ReactSelectComponents.MultiValueRemove
                                {...state}
                                innerProps={{...state.innerProps, className: SELECT_TEST_CLASSNAMES.REMOVE_VALUE}}
                            />
                        );
                    }
                }}
                isSearchable={false}
                theme={getTheme}
                styles={{...styles, ...customStyles}}
                {...restProps}
                className={!labelContent ? className : undefined}
                placeholder={placeholder || "Wybierz"}
                ref={ref}
            />
        </Wrapper>
    );
}

export const Select = forwardRef(SelectBase);
